import { createAction, props } from "@ngrx/store";
import { UserInfo } from "src/app/models/users/user.models";

export const addUser = createAction('Add User' , props<UserInfo>());
export const removeUser = createAction('Remove User' , props<UserInfo>())
export const clearUser = createAction('Clear User');
export const returnUsers = createAction('Return User');